<template>
  <!-- 收藏统计 -->
  <div class="orderInterfaceInfo">
    <!-- 面包屑导航 -->
    <page-bar @back="goBack" @refresh="handleRefresh" :title="$route.meta.title"></page-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 80px)"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column
        label="序号"
        align="center"
        width="50">
        <template slot-scope="scope">
          <span>{{(currPage - 1) * pageSize + scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="商品编号">
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="商品名称">
      </el-table-column>
      <el-table-column
        prop="num"
        align="center"
        show-overflow-tooltip
        label="商品数量">
      </el-table-column>
      <el-table-column
        prop="price"
        align="center"
        show-overflow-tooltip
        label="商品价格">
      </el-table-column>
      <el-table-column
        prop="discount"
        align="center"
        show-overflow-tooltip
        label="扣率">
      </el-table-column>
      <el-table-column
        prop="rem"
        align="center"
        show-overflow-tooltip
        label="活动详情">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  name: 'orderInterfaceInfo',
  data() {
    return {
      id: '',
      /**表格数据 */
      tableData: [],
      /**搜索表单 */
      searchForm: {
        name: ''
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    }
  },
  mounted(){
    if(this.$route.query.prams){
      let prams = JSON.parse(decodeURIComponent(this.$route.query.prams))
      if(prams){
        this.id = prams.id
        this.getTableData()
      }
    }
  },
  methods:{
    updata(){
      if(this.id){
        this.getTableData()
      }
    },
    goBack() {
      this.$router.go(-1);
      this.$destroy()
    },
    /**获取表格数据 */
    getTableData(){
      let data = {
        type: "Int_order_info",
        strWhere: this.id,
      }
      let proc = "Proc_Admin_GoodsList" // 存储过程名
      let type = "ReturnList"
      this.$requestSys({
        method: 'post',
        url: "goods/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
      }).then(res => {
        this.tableData = []
        this.allPage = 0
        if(res.flag == 0){
          this.allPage = res.recordCount
          this.tableData = res.data.map(item => ({
            id: item.spid, // 商品编号
            name: item.GoodsName, // 商品名称
            num: item.Quantity, // 商品数量
            price: item.Goodsprice, // 商品价格
            discount: item.Discount, // 扣率
            rem: item.Describe, // 活动详情
          }))
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    /**刷新数据 */
    handleRefresh(){
      this.getTableData()
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val
      this.getTableData()
    }
  }
}
</script>

<style scoped>
.orderInterfaceInfo{
  width: 100%;
  height: 100%;
}
</style>
